const contractStore = {
  state: {
    hasPlanEmbarcador: false,
    contracts: undefined,
    contractSelected: undefined
  },
  mutations:{
    hasPlanEmbarcador(state, hasPlan){
      state.hasPlanEmbarcador = hasPlan;
    },
    setContracts(state, c){
      state.contracts = c;
    },
    setContractSelected(state, c){
      state.contractSelected = c;
    }
  },
  getters:{
    getContractById: (state, getters) => (id) => {
      if(state.contracts === undefined){
        return undefined;
      }
      return state.contracts.find(p => p.contractId == id);
    },

  },
}

export default contractStore;



// WEBPACK FOOTER //
// ./src/store/contract.js